/* Rekover : photos produit.
   1. Reflet : une bande de lumière passe une fois sur chaque photo quand elle apparaît à l'écran
      (et à nouveau sur la fiche produit quand on change de photo).
   2. Zoom : sur la fiche produit, un clic sur la photo l'ouvre en grand ; flèches, glisser du doigt, Échap pour fermer. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var T = {
    fr: { close: 'Fermer', prev: 'Photo précédente', next: 'Photo suivante', zoom: 'Photo en grand' },
    nl: { close: 'Sluiten', prev: 'Vorige foto', next: 'Volgende foto', zoom: 'Foto vergroot' },
    en: { close: 'Close', prev: 'Previous photo', next: 'Next photo', zoom: 'Enlarged photo' }
  }[lang] || null;
  if (!T) T = { close: 'Fermer', prev: 'Photo précédente', next: 'Photo suivante', zoom: 'Photo en grand' };

  /* ---------- 1. le reflet ---------- */
  function shine(el) {
    if (reduce || !el) return;
    el.classList.remove('is-shine'); void el.offsetWidth; el.classList.add('is-shine');
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      if (e.target.classList.contains('product__media-item') && !e.target.classList.contains('is-active')) return;
      shine(e.target);
    });
  }, { threshold: 0.45 }) : null;
  function scan(root) {
    (root || document).querySelectorAll('.rk-studio').forEach(function (el) {
      if (el.dataset.rkShine) return; el.dataset.rkShine = '1';
      if (io) io.observe(el);
      if (el.classList.contains('product__media-item')) {
        new MutationObserver(function () {
          var on = el.classList.contains('is-active');
          if (on && !el.dataset.rkOn) shine(el);
          el.dataset.rkOn = on ? '1' : '';
        }).observe(el, { attributes: true, attributeFilter: ['class'] });
        el.dataset.rkOn = el.classList.contains('is-active') ? '1' : '';
      }
    });
  }

  /* ---------- 2. le zoom ---------- */
  var lb, lbImg, lbCount, list = [], idx = 0, lastFocus = null;
  function bigSrc(img) {
    var set = img.getAttribute('srcset');
    if (set) { var parts = set.split(',').map(function (p) { return p.trim().split(/\s+/)[0]; }); return parts[parts.length - 1]; }
    return img.currentSrc || img.src;
  }
  function build() {
    lb = document.createElement('div');
    lb.className = 'rk-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', T.zoom);
    lb.innerHTML = '<img class="rk-lb__img" alt="">' +
      '<button type="button" class="rk-lb__btn rk-lb__close">×</button>' +
      '<button type="button" class="rk-lb__btn rk-lb__prev">‹</button>' +
      '<button type="button" class="rk-lb__btn rk-lb__next">›</button>' +
      '<p class="rk-lb__count" aria-live="polite"></p>';
    lb.querySelector('.rk-lb__close').setAttribute('aria-label', T.close);
    lb.querySelector('.rk-lb__prev').setAttribute('aria-label', T.prev);
    lb.querySelector('.rk-lb__next').setAttribute('aria-label', T.next);
    lbImg = lb.querySelector('.rk-lb__img'); lbCount = lb.querySelector('.rk-lb__count');
    document.body.appendChild(lb);
    lb.querySelector('.rk-lb__close').addEventListener('click', close);
    lb.querySelector('.rk-lb__prev').addEventListener('click', function () { go(-1); });
    lb.querySelector('.rk-lb__next').addEventListener('click', function () { go(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    var x0 = null, y0 = null;
    lb.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; } else x0 = null; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? 1 : -1);
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.3) close();
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'Tab') { e.preventDefault(); lb.querySelector('.rk-lb__close').focus(); }
    });
  }
  function show(i, swap) {
    idx = (i + list.length) % list.length;
    var it = list[idx];
    var set = function () { lbImg.src = it.src; lbImg.alt = it.alt; lbImg.classList.remove('is-swap'); };
    if (swap && !reduce) { lbImg.classList.add('is-swap'); setTimeout(set, 180); } else set();
    lbCount.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    var multi = list.length > 1;
    lb.querySelector('.rk-lb__prev').hidden = !multi; lb.querySelector('.rk-lb__next').hidden = !multi;
  }
  function go(d) { if (list.length > 1) show(idx + d, true); }
  function open(items, i) {
    if (!lb) build();
    list = items; lastFocus = document.activeElement;
    show(i, false);
    document.documentElement.style.overflow = 'hidden';
    lb.classList.add('is-open');
    lb.querySelector('.rk-lb__close').focus({ preventScroll: true });
  }
  function close() {
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.product__media-item img');
    if (!img) return;
    var gallery = img.closest('.product__main-media');
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item:not([data-rk-out]) > img'));
    if (!imgs.length) return;
    e.preventDefault();
    var items = imgs.map(function (m) { return { src: bigSrc(m), alt: m.alt || '' }; });
    open(items, Math.max(0, imgs.indexOf(img)));
  });

  /* ---------- 3. un modèle = ses photos ----------
     Une photo dont le texte alternatif finit par « #nom » appartient au modèle « nom » (ex. « #mains-de-massage »).
     Quand la photo active appartient à un modèle, les photos des autres modèles sont masquées ; les photos sans « # »
     restent toujours visibles. */
  function groupFilter(gallery) {
    var current = '';
    function apply() {
      var act = gallery.querySelector('.product__media-item.is-active');
      var g = act && act.getAttribute('data-group');
      if (g) current = g;
      if (!current) return;
      gallery.querySelectorAll('[data-group]').forEach(function (el) {
        var out = el.getAttribute('data-group') !== current;
        if (out) el.setAttribute('data-rk-out', ''); else el.removeAttribute('data-rk-out');
      });
    }
    apply();
    gallery.querySelectorAll('.product__media-item').forEach(function (it) {
      new MutationObserver(function () { if (it.classList.contains('is-active')) apply(); }).observe(it, { attributes: true, attributeFilter: ['class'] });
    });
  }
  function groups(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (g) {
      if (g.dataset.rkGroups || !g.querySelector('[data-group]')) return;
      g.dataset.rkGroups = '1'; groupFilter(g);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); groups(); }); else { scan(); groups(); }
  document.addEventListener('shopify:section:load', function (e) { groups(e.target); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
